import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@stores/store';
import { buildListableDashboardModules } from '../utils/utils';
import { SubmoduleFilterRegistry, useSubmoduleFilterRegistry } from './useSubmoduleFilterRegistry';

type UseDashboardSelectorOptions = {
  allowedSubmoduleTypes?: string[];
  includePermissionSubmodules?: boolean;
};

type UseDashboardSelectorResult = {
  filterRegistry: SubmoduleFilterRegistry;
  refreshSubmoduleFilters: (submoduleId: string) => Promise<void>;
};

export const useDashboardSelector = ({
  allowedSubmoduleTypes,
  includePermissionSubmodules,
}: UseDashboardSelectorOptions = {}): UseDashboardSelectorResult => {
  const userManagementModules = useSelector(
    (state: RootState) => state.ModulesData.userManagementModules,
  );

  const allSubmoduleIds = useMemo(
    () =>
      buildListableDashboardModules(
        userManagementModules,
        includePermissionSubmodules,
        allowedSubmoduleTypes,
      ).flatMap((m) => m.submodules.map((s) => s.submoduleId)),
    [userManagementModules, includePermissionSubmodules, allowedSubmoduleTypes],
  );

  const { filterRegistry, refreshSubmoduleFilters } = useSubmoduleFilterRegistry(allSubmoduleIds);

  return { filterRegistry, refreshSubmoduleFilters };
};
